import styled from 'styled-components';
import { themeProvider } from '@swipejobs/frontend-theme-provider';

interface ModalStyleProps {
    top: string;
    left: string;
    border?: string;
}

export const ModalTitle = styled.div`
    font-size: ${() => themeProvider.getTypography().font.size.normalPlus};
    color: ${() => themeProvider.getColors().title.defaultColor};
    font-weight: bold;
    padding-bottom: 10px;
    display: flex;
    margin-bottom: 10px;
    justify-content: space-between;
    border-bottom: ${() => themeProvider.getFraming().border.tiny} ${() => themeProvider.getColors().modal.headerBorder};
`;

export const ModalFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 10px;
`;

export const ModalLabel = styled.div`
    color: ${() => themeProvider.getColors().text.secondaryTextColor};
`;

export const ModalStyle = styled.div<ModalStyleProps>`
     top: ${(props) => props.top};
     left: ${(props) => props.left};
     transform: translate(-${(props) => props.top}, -${(props) => props.left});
     position: absolute;
     background-color: ${() => themeProvider.getColors().modal.bodyBackground};
     box-shadow: rgb(140, 140, 140) 0px 0px 3px;
     padding: 15px 15px 10px;
     outline: none;    
     color: ${() => themeProvider.getColors().text.secondaryTextColor};
     border-radius: ${(props) => props.border};
     width: 450px;
    @media (max-width: 450px) {
      padding: 6px;
      width: 100%;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2px
`;
export const ModalCloseIcon = styled.div`
    cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/components/modal/styles.tsx